import { useCallback, useEffect, useState } from "react";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Avatar, Button, message, Table } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { getAllRequest } from "../../services/ApiService";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";
import { decryptObject } from "../GlobalFunction";
import "../MasterDatabase/MasterDB.css";

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
};

const AllRequest = () => {
  const location = useLocation();

  const [allRequest, setAllRequest] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Get "status" from Dashboard URL (like ?status=live)
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");

  const userType = decryptObject(
    sessionStorage.getItem("sessioninfo")
  )?.userType;

  // Generate dynamic columns
  const generateColumnsFromData = (ColumnList) => {
    const keys = ColumnList.filter(
      (key) =>
        key !== "assign_to" &&
        key !== "id" &&
        key !== "onboardId" &&
        key !== "organization_id" &&
        key !== "employee_full_name" &&
        key !== "Employee_Name" &&
        key !== "Employee_First_Name" &&
        key !== "Employee_Middle_Name" &&
        key !== "Employee_Last_Name" &&
        key !== "Remarks" &&
        key !== "Employee_Status"
    );

    const dynamicColumns = keys.map((key) => ({
      title: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      dataIndex: key,
      key: key,
      ellipsis: true,
      render: (text) => (
        <div style={{ minWidth: 100, whiteSpace: "nowrap" }}>
          {text && text !== "null" ? text : ""}
        </div>
      ),
    }));

    // Add Employee Name column
    dynamicColumns.unshift({
      title: "Employee Name",
      fixed: "left",
      key: "employee_full_name",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "0.1rem", alignItems: "center" }}>
          <Avatar size={20} icon={<UserOutlined />} />
          <span
            type="text"
            style={{ fontSize: "0.8rem", padding: "0.5rem 1rem" }}
          >
            {record["Employee_Name"] || ""}
          </span>
        </div>
      ),
      responsive: ["xs", "sm", "sm"],
    });

    return dynamicColumns;
  };

  const fetchData = async (page = 1, pageSize = 100) => {
    setLoading(true);
    try {
      const filters = {};
      if (status) filters.status = status;

      let requestRes = await getAllRequest(page, pageSize, null, filters);

      if (typeof requestRes === "string") {
        requestRes = requestRes.replace(/\bNaN\b/g, "null");
        requestRes = JSON.parse(requestRes);
      }

      if (requestRes?.responseCode === 200) {
        setTotal(requestRes?.total_records || 0);
        const Response = requestRes?.onboard_forms || [];
        setAllRequest(Response);

        if (Response.length > 0) {
          const dynamicCols = generateColumnsFromData(requestRes?.column_keys);
          setColumns(dynamicCols);
        } else {
          setColumns([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch employees");
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchData = useCallback(
    debounce((page, pageSize) => {
      fetchData(page, pageSize);
    }, 500),
    [status]
  );

  // Fetch data whenever status changes (or page loads)
  useEffect(() => {
    fetchData(1, 100);
  }, [status]);

  const handleTableChange = (paginationInfo) => {
    const newPagination = {
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    };
    setPagination(newPagination);
    fetchData(paginationInfo.current, paginationInfo.pageSize);
  };

  return (
    <div className="main-box">
      <Sidebar activeId={0} />
      <main className="main-content">
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <Header
            title={`${
              status
                ? `${status.charAt(0).toUpperCase() + status.slice(1)} `
                : ""
            }Employees`}
          />
          <div style={{ flex: 1, padding: "1rem", overflowY: "auto" }}>
            <Spin spinning={loading} size="large" tip="Loading...">
              <Table
                columns={columns}
                dataSource={allRequest}
                rowKey="onboardId"
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  total: total,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} records`,
                }}
                onChange={handleTableChange}
                scroll={{ x: "max-content", y: 420 }}
                style={{
                  fontSize: "0.7rem",
                  borderRadius: "1.5rem",
                  background: "#FFF",
                  marginTop: "1rem",
                  height: "70vh",
                }}
                className="masterTb custom-scrollbar"
              />
            </Spin>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllRequest;
